/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Link, useParams, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Breadcrumb from '../../components/Common/Breadcrumb';
import { fetchBlogWithAuthor } from "../../services/blogService";
import { decrypt, encrypt } from '../../utils/encryption';
import FormattedContent from "../../components/Common/FormattedContent";
import LoadingSpinner from "../../components/Common/LoadingSpinner";
import '../../assets/css/BlogDetails.css'; // Import the CSS file
import { BASE_URL_IMAGE } from '../../config/api';


const Blogdetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const decryptedId = decrypt(id);
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [readingTime, setReadingTime] = useState(0);
  const [isBookmarked, setIsBookmarked] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const blogWithAuthor = await fetchBlogWithAuthor(decryptedId);
        setBlog(blogWithAuthor);

        // Calculate reading time (assuming 200 words per minute)
        if (blogWithAuthor.blog_description) {
          const wordCount = blogWithAuthor.blog_description.split(' ').length;
          const estimatedTime = Math.ceil(wordCount / 200);
          setReadingTime(estimatedTime);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [decryptedId]);

  console.log(blog)

  const handleBookmark = () => {
    setIsBookmarked(!isBookmarked);
    // Here you would typically save to localStorage or make an API call
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: blog.blog_title,
        text: blog.blog_description.substring(0, 100) + '...',
        url: window.location.href,
      });
    } else {
      // Fallback: copy to clipboard
      navigator.clipboard.writeText(window.location.href);
      alert('Link copied to clipboard!');
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="main-wrapper">
        <Header />
        <Sidebar id='menu-item11' id1='menu-items11' activeClassName='blog-details' />
        <div className="page-wrapper">
          <div className="content">
            <LoadingSpinner message="Loading blog details..." />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="main-wrapper">
        <Header />
        <Sidebar id='menu-item11' id1='menu-items11' activeClassName='blog-details' />
        <div className="page-wrapper">
          <div className="content">
            <div className="error-container">
              <div className="error-content">
                <FeatherIcon icon="alert-circle" size={48} className="error-icon" />
                <h3>Error Loading Blog</h3>
                <p>{error}</p>
                <button
                  className="btn btn-primary"
                  onClick={() => navigate('/blogs')}
                >
                  Back to Blogs
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="main-wrapper">
        <Header />
        <Sidebar id='menu-item11' id1='menu-items11' activeClassName='blog-details' />
        <div className="page-wrapper">
          <div className="content">
            <div className="not-found-container">
              <div className="not-found-content">
                <FeatherIcon icon="file-text" size={48} className="not-found-icon" />
                <h3>Blog Not Found</h3>
                <p>The blog you're looking for doesn't exist or has been removed.</p>
                <button
                  className="btn btn-primary"
                  onClick={() => navigate('/blogs')}
                >
                  Back to Blogs
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const breadcrumbItems = [
    { label: "Blogs", path: "/blogs" },
    { label: blog.blog_title },
  ];

  return (
    <div>
      <div className="main-wrapper">
        <Header />
        <Sidebar id='menu-item11' id1='menu-items11' activeClassName='blog-details' />
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <Breadcrumb items={breadcrumbItems} />
                </div>
              </div>
            </div>

            {/* Blog Content */}
            <div className="row">
              <div className="col-lg-8 col-md-12">
                <div className="blog-view">
                  <article className="blog blog-single-post">
                    {/* Blog Header */}
                    <div className="blog-header">
                      <div className="blog-category-badge">
                        <span className="badge bg-primary">{blog.blog_category}</span>
                      </div>
                      <h1 className="blog-title">{blog.blog_title || 'No title available'}</h1>

                      {/* Blog Meta Info */}
                      <div className="blog-meta">
                        <div className="meta-item">
                          <img
                            className="author-avatar"
                            src={`${BASE_URL_IMAGE}/uploads/userProfiles/${blog.user.user_profile_img}`}
                            alt={blog.blog_author_name}
                          />
                          <div className="author-info">
                            <span className="author-name">{blog.blog_author_name || 'Unknown author'}</span>
                            <span className="author-designation">{blog.user.user_designation || 'Author'}</span>
                          </div>
                        </div>
                        <div className="meta-divider">•</div>
                        <div className="meta-item">
                          <FeatherIcon icon="calendar" size={16} />
                          <span>{formatDate(blog.createdAt) || 'No date'}</span>
                        </div>
                        <div className="meta-divider">•</div>
                        <div className="meta-item">
                          <FeatherIcon icon="clock" size={16} />
                          <span>{readingTime} min read</span>
                        </div>
                      </div>
                    </div>

                    {/* Blog Image */}
                    <div className="blog-image-container">
                      <img
                        className="blog-featured-image"
                        src={`${BASE_URL_IMAGE}/uploads/blogImages/${blog.blog_image}`}
                        alt={blog.blog_title}
                      />
                    </div>

                    {/* Blog Content */}
                    <div className="blog-content">
                      <div className="blog-description">
                        <FormattedContent htmlContent={blog.blog_description} />
                      </div>

                      {/* Tags */}
                      {blog.tags && (
                        <div className="blog-tags">
                          <h5>Tags:</h5>
                          <div className="tags-container">
                            {blog.tags.split(',').map((tag, index) => (
                              <span key={index} className="tag">
                                #{tag.trim()}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </article>
                </div>
              </div>

              {/* Sidebar */}
              <div className="col-lg-4 col-md-12">
                <div className="blog-sidebar">
                  {/* Author Widget */}
                  <div className="author-profile-card">
                    <img
                      className="profile-image-circle"
                      alt="Author"
                      src={`${BASE_URL_IMAGE}/uploads/userProfiles/${blog.user.user_profile_img}`}
                    />
                    <div className="profile-info">
                      <h4 className="profile-name">{blog.blog_author_name || 'Unknown author'}</h4>
                      <p className="profile-role">{blog.user.user_designation || 'Author'}</p>
                    </div>
                  </div>

                  {/* Quick Actions */}
                  <div className="quick-actions-widget">
                    <h5>Quick Actions</h5>
                    <div className="action-buttons">
                      <Link
                        to="/blogs"
                        className="btn btn-outline-primary btn-block"
                      >
                        <FeatherIcon icon="arrow-left" size={16} className="me-2" />
                        Back to Blogs
                      </Link>
                      <Link
                        to={`/edit-blog/${encodeURIComponent(encrypt(blog.blog_id))}`}
                        className="btn btn-primary btn-block"
                      >
                        <FeatherIcon icon="edit" size={16} className="me-2" />
                        Edit Blog
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sidebar-overlay" data-reff="" />
    </div>
  );
};

export default Blogdetails;